/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Alert_TitleInputs */

const en_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alert`)
};

const fr_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerte`)
};

const de_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alarm`)
};

const it_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attenzione`)
};

const ru_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тревога`)
};

const es_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerta`)
};

const zh_cn2_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`警报`)
};

const ja_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`警告`)
};

const hi_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चेतावनी`)
};

const pt_pt2_iframe_remote_alert_title = /** @type {(inputs: Iframe_Remote_Alert_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerta`)
};

/**
* | output |
* | --- |
* | "Alert" |
*
* @param {Iframe_Remote_Alert_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_alert_title = /** @type {((inputs?: Iframe_Remote_Alert_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Alert_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_alert_title(inputs)
	if (locale === "de") return de_iframe_remote_alert_title(inputs)
	if (locale === "it") return it_iframe_remote_alert_title(inputs)
	if (locale === "ru") return ru_iframe_remote_alert_title(inputs)
	if (locale === "es") return es_iframe_remote_alert_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_alert_title(inputs)
	if (locale === "ja") return ja_iframe_remote_alert_title(inputs)
	if (locale === "hi") return hi_iframe_remote_alert_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_alert_title(inputs)
	return en_iframe_remote_alert_title(inputs)
});